import { Suggestion } from '@models/Suggestion/Suggestion.interface';

export interface SearchState {
  suggestions: Suggestion[];
  moreCount: number;
  isLoading: boolean;
  isBlocked: boolean;
  searchValue: string;
}

export const SET_SUGGESTIONS = 'SET_SUGGESTIONS';
export const CLEAR_SUGGESTIONS = 'CLEAR_SUGGESTIONS';
export const SET_COUNT = 'SET_COUNT';
export const CLEAR_COUNT = 'CLEAR_COUNT';
export const START_SEARCH_LOADING = 'START_SEARCH_LOADING';
export const FINISH_SEARCH_LOADING = 'FINISH_SEARCH_LOADING';
export const SET_BLOCKED = 'SET_BLOCKED';
export const SET_SEARCH_VALUE = 'SET_SEARCH_VALUE';

interface SetSearchValueAction {
  type: typeof SET_SEARCH_VALUE;
  value: string;
}

interface SetSuggestionsAction {
  type: typeof SET_SUGGESTIONS;
  suggestions: Suggestion[];
}

interface ClearSuggestionsAction {
  type: typeof CLEAR_SUGGESTIONS;
}

interface SetCountAction {
  type: typeof SET_COUNT;
  payload: number;
}

interface ClearCountAction {
  type: typeof CLEAR_COUNT;
}

interface StartLoadingAction {
  type: typeof START_SEARCH_LOADING;
}

interface FinishLoadingAction {
  type: typeof FINISH_SEARCH_LOADING;
}

interface SetBlockedAction {
  type: typeof SET_BLOCKED;
  isBlocked: boolean;
}

export type SearchActionTypes =
  | SetSearchValueAction
  | SetBlockedAction
  | SetSuggestionsAction
  | ClearSuggestionsAction
  | SetCountAction
  | ClearCountAction
  | StartLoadingAction
  | FinishLoadingAction;
